const parisDateTimeFormatter = new Intl.DateTimeFormat('fr-FR', {
  timeZone: 'Europe/Paris',
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

const parisDayFormatter = new Intl.DateTimeFormat('fr-FR', {
  timeZone: 'Europe/Paris',
  day: '2-digit', month: '2-digit', year: 'numeric',
});

const parisPartsFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Paris', hourCycle: 'h23',
  year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
});

const timeZoneSuffixPattern = /(Z|[+-]\d{2}:?\d{2})$/i;

export function formatParisDate(value: string): string {
  return parisDateTimeFormatter.format(parseUtcDate(value)).replace(',', ' à');
}

export function formatParisDay(value: string): string {
  return parisDayFormatter.format(parseUtcDate(value));
}

export function toParisDateTimeInput(value: string): string {
  const parts = dateParts(parseUtcDate(value));
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

export function parisDateTimeInputToUtc(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value);
  if (!match) throw new Error('Date de publication invalide.');
  const [, year, month, day, hour, minute] = match;
  const utcGuess = Date.UTC(+year, +month - 1, +day, +hour, +minute);
  const parisAtGuess = dateParts(new Date(utcGuess));
  const parisAsUtc = Date.UTC(+parisAtGuess.year, +parisAtGuess.month - 1, +parisAtGuess.day,
    +parisAtGuess.hour, +parisAtGuess.minute, +parisAtGuess.second);
  return new Date(utcGuess - (parisAsUtc - utcGuess)).toISOString();
}

function parseUtcDate(value: string): Date {
  const normalized = value.trim();
  return new Date(timeZoneSuffixPattern.test(normalized) ? normalized : `${normalized}Z`);
}

function dateParts(date: Date): Record<string, string> {
  return Object.fromEntries(parisPartsFormatter.formatToParts(date)
    .filter(part => part.type !== 'literal')
    .map(part => [part.type, part.value]));
}
